<div class="table-grid">
  <div class="table-grid-headers">
    <div
      [hidden]="!showHeader"
      *ngFor="let column of columns"
      class="table-grid-header {{ column.flex >= 0 && 'flex-' + column.flex }}"
      [style.flex-basis]="column.flexBasis"
    >
      {{ column.name }}
      <lfx-filter-dropdown
        (filterAction)="filterAction.emit({ column: column, filter: $event })"
        *ngIf="column.filterData"
        [title]="column.filterData.title"
        [filterData]="column.filterData.data"
      ></lfx-filter-dropdown>
    </div>
    <div *ngIf="canEdit || canDelete" class="table-grid-header actions-cell">
      {{ defaultActionsTitle }}
    </div>
  </div>
  <div class="items-wrapper scroll" [style.max-height]="maxHeight || 'auto'">
    <div
      *ngIf="!data.length"
      class="table-row height-70 f-s-14 f-w-400 justify-content-center"
    >
      {{ emptyDataMessage }}
    </div>
    <ng-container *ngFor="let item of data">
      <div
        class="{{ columns.length >= 2 ? 'table-row' : 'table-child-row' }}"
        [style.min-height]="minHeight || 'auto'"
      >
        <div
          *ngFor="let column of columns"
          [style.flex-basis]="column.flexBasis"
          class="{{ columns.length >= 2 ? 'table-cell' : 'child-cell' }} {{
            column.flex >= 0 && 'flex-' + column.flex
          }}"
        >
          <ng-container *ngIf="column.template">
            <ng-container
              *ngTemplateOutlet="column.template; context: { row: item }"
            ></ng-container>
          </ng-container>
          <div
            *ngIf="!column.template"
            class="row align-items-center no-gutters"
          >
            <div
              class="col-auto"
              *ngIf="
                getType(item[column.prop]) === 'object' &&
                $any(item[column.prop])?.image
              "
            >
              <span
                class="pull-left mr-2"
                [class.img-border]="$any(item[column.prop]).border"
              >
                <img class="cell-image" src="{{ $any(item[column.prop]).image }}" />
              </span>
            </div>
            <div class="col-auto" *ngIf="checkImage(item[column.prop])">
              <span
                class="pull-left mr-2 img-empty-state"
                [class.img-border]="$any(item[column.prop]).border"
              >
                <i
                  class="cell-image-default {{ $any(item[column.prop]).defaultIcon }}"
                ></i>
              </span>
            </div>
            <div class="col">
              <span
                data-container="body"
                *ngIf="
                  getType(item[column.prop]) === 'string' ||
                  getType(item[column.prop]) === 'number'
                "
                class="text-large"
                [class.text-grey-600]="grayColor"
                [ngbTooltip]="tooltip($any(item[column.prop]), column.textEllipsis)"
                placement="right"
                >{{
                  column.textEllipsis
                    ? ($any(item[column.prop]) | ellipsis: column.textEllipsis)
                    : $any(item[column.prop])
                }}</span
              >
              <span
                data-container="body"
                *ngIf="
                  getType(item[column.prop]) === 'object' &&
                  $any(item[column.prop]).text
                "
                class="text-large {{
                  $any(item[column.prop])?.color &&
                    'lfx-text-' + $any(item[column.prop]).color
                }}"
                [class.text-bold]="$any(item[column.prop])?.bold"
                [class.text-grey-600]="!$any(item[column.prop]).subtext && grayColor"
                [ngbTooltip]="
                  tooltip($any(item[column.prop]).text, column.textEllipsis)
                "
                placement="right"
              >
                {{
                  column.textEllipsis
                    ? ($any(item[column.prop]).text | ellipsis: column.textEllipsis)
                    : $any(item[column.prop]).text
                }}
                <ng-template #popBody>
                  <i class="fas fa-info-circle"></i>
                  <span>{{ $any(item[column.prop]).tooltipText }}</span>
                </ng-template>
                <i
                  *ngIf="$any(item[column.prop]).tooltipText"
                  class="fas fa-info-circle {{
                    !$any(item[column.prop]).subtext && grayColor && 'text-grey-600'
                  }}"
                  popoverClass="popover-custom {{
                    !$any(item[column.prop]).subtext && grayColor && 'text-grey-600'
                  }}"
                  placement="right"
                  triggers="mouseenter:mouseleave"
                  [ngbPopover]="popBody"
                ></i>
              </span>
              <span
                data-container="body"
                *ngIf="
                  getType(item[column.prop]) === 'object' &&
                  $any(item[column.prop]).subtext
                "
                class="text-small text-grey-600"
                [ngbTooltip]="
                  tooltip($any(item[column.prop]).subtext, column.subTextEllipsis)
                "
                >{{
                  column.subTextEllipsis
                    ? ($any(item[column.prop]).subtext
                      | ellipsis: column.subTextEllipsis)
                    : $any(item[column.prop]).subtext
                }}</span
              >
              <span
                *ngIf="
                  getType(item[column.prop]) === 'object' &&
                  $any(item[column.prop]).callToAction
                "
                class="text-small text-grey-600 call-to-action-wrapper"
                >{{ $any(item[column.prop]).callToAction?.prefixText }}
                <span
                  class="call-to-action"
                  (click)="customAction(column, item)"
                  >{{ $any(item[column.prop]).callToAction?.actionText }}</span
                ></span
              >
              <span
                data-container="body"
                *ngIf="
                  getType(item[column.prop]) === 'object' &&
                  $any(item[column.prop]).extraText
                "
                class="text-small"
                [class.lfx-text-warning]="
                  $any(item[column.prop]).extraText.style === 'warning'
                "
                [class.text-bold]="$any(item[column.prop]).extraText.bold"
                [class.text-grey-600]="
                  $any(item[column.prop]).extraText.style === 'gray'
                "
                [ngbTooltip]="
                  tooltip(
                    $any(item[column.prop]).extraText.text,
                    column.subTextEllipsis
                  )
                "
                >{{
                  column.subTextEllipsis
                    ? ($any(item[column.prop]).extraText.text
                      | ellipsis: column.subTextEllipsis)
                    : $any(item[column.prop]).extraText.text
                }}</span
              >
              <span
                class="expand-action"
                *ngIf="column.expandAction && item.children?.length"
                (click)="toggleChildren(item)"
                >{{ item.expanded ? collapseText : expandText }}</span
              >
            </div>
          </div>
        </div>
        <div *ngIf="canEdit || canDelete" class="table-cell actions-cell">
          <i
            *ngIf="canEdit && !item.manageDisabled"
            class="action-button action-button-edit fas fa-pencil"
            (click)="edit(item, null)"
          ></i>
          <i
            *ngIf="canDelete && !item.manageDisabled"
            class="action-button action-button-delete fas fa-trash"
            (click)="delete(item, null)"
          ></i>
        </div>
      </div>
      <div
        class="children-wrapper"
        [style]="childrenWidth()"
        *ngIf="item.children && item.expanded"
      >
        <div class="scroll-area">
          <div *ngFor="let child of item.children" class="table-child-row">
            <!-- <section class='child-cell-empty'></section> -->
            <ng-container *ngFor="let column of columns">
              <div *ngIf="!column.hideInChild" class="child-cell">
                <span
                  *ngIf="
                    getType(child[column.prop]) === 'string' ||
                    getType(child[column.prop]) === 'number'
                  "
                  class="text-large"
                  [class.text-grey-600]="grayColor"
                  >{{ child[column.prop] }}</span
                >
                <img
                  class="cell-image"
                  *ngIf="
                    getType(child[column.prop]) === 'object' &&
                    $any(child[column.prop]).image
                  "
                  src="{{ $any(child[column.prop]).image }}"
                />
                <span
                  *ngIf="
                    getType(child[column.prop]) === 'object' &&
                    $any(child[column.prop]).text
                  "
                  >{{ $any(child[column.prop]).text }}</span
                >
                <ng-container
                  *ngIf="
                    getType(child[column.prop]) === 'object' &&
                    $any(child[column.prop]).elementRef
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="$any(child[column.prop]); context: { row: item }"
                  ></ng-container>
                </ng-container>
              </div>
            </ng-container>
            <div *ngIf="canEdit || canDelete" class="child-cell actions-cell">
              <i
                *ngIf="canEdit && !child.manageDisabled"
                class="action-button action-button-edit fas fa-pencil"
                (click)="edit(child, item)"
              ></i>
              <i
                *ngIf="canDelete && !child.manageDisabled"
                class="action-button action-button-delete fas fa-trash"
                (click)="delete(child, item)"
              ></i>
            </div>
          </div>
        </div>
        <span class="collapse-action float-right" (click)="toggleChildren(item)"
          ><i class="fas fa-times"></i> {{ closeText }}</span
        >
      </div>
    </ng-container>
  </div>
</div>
